import React from "react";
import { useParams } from "react-router";
import { useSelector } from "react-redux";

import KpiNumberTile from "./KpiNumberTile";
import { sumRecommendations, sumRecommended, nv, periodDelta } from "./utils";
import { useTrendsData } from "./hooks/useTrendsData";

const pct = (impl, rec) => (rec > 0 ? (impl / rec) * 100 : 0);
const pickImplemented = (s) => sumRecommendations(s.recommendationStats || {});
const pickRecommended = (s) => sumRecommended(s.recommendationStats || {});

export default function KpiRecommendationTile({ startDate, endDate, lastN, onFilter, onInvestigate }) {
    const { workspaceNumber } = useParams();
    const live = useSelector((s) => s.stats?.workspaceStats);
    const { series, days } = useTrendsData({ workspaceNumber, startDate, endDate, lastN });

    const impl = sumRecommendations(live?.recommendationStats || {});
    const rec  = sumRecommended(live?.recommendationStats || {});
    const value = Math.round(pct(impl, rec));

    const implSeries = series(pickImplemented);
    const recSeries  = series(pickRecommended);
    const pctSeries = implSeries.map((d, i) =>
        d.value == null
            ? { value: null }
            : { value: pct(Number(d.value) || 0, Number(recSeries[i]?.value) || 0) });

    return (
        <KpiNumberTile
            title="Recommendations"
            info="% of recommendations implemented right now (implemented ÷ recommended). Up = good. Change compares implemented count against the start of the period."
            tone={value >= 100 ? "#15803d" : undefined}
            sparkColor="#2563eb"
            value={live?.fetched ? value : "—"}
            unit="%"
            valueTooltip={live?.fetched ? `${nv(impl)} of ${nv(rec)} implemented` : undefined}
            delta={periodDelta(impl, days, pickImplemented)}
            invertDelta
            sparkSeries={pctSeries}
            onFilter={onFilter}
            onInvestigate={onInvestigate}
        />
    );
}
